<div class="col px-lg-5 px-2">
	<div class="row my-5">
		<ul class="nav border-bottom">
			<li class="nav-item" *ngFor="let tab of tabs">
				<a
					class="nav-link theme-title-font theme-main-color"
					(click)="changeActiveTab(tab.id)"
					role="button"
					[ngClass]="{
						'active fw-bold border-0 border-bottom border-3 border-custom-theme':
							isTabActive(tab.id)
					}"
					>{{ tab.name }}</a
				>
			</li>
		</ul>
	</div>

	<div class="row my-2 p-2" *ngIf="!isTabActive(5)">
		<ul
			class="nav border-bottom d-flex justify-content-center"
			*ngIf="isTabActive(1)"
		>
			<li class="nav-item" *ngFor="let tab of reportTypeTabs">
				<a
					class="nav-link theme-title-font theme-main-color"
					(click)="changeActiveReportTypeTab(tab.id)"
					role="button"
					[ngClass]="{
						'active fw-bold border-0 border-bottom border-3 border-custom-theme':
							isReportTypeTabActive(tab.id)
					}"
					>{{ tab.name }}</a
				>
			</li>
		</ul>

		<div
			*ngIf="isReportTypeTabActive(1) && isTabActive(1)"
			class="d-flex justify-content-center m-3"
		>
			<div class="col-xs-1 col-md-1 col-lg-1 form-group me-3">
				<input
					type="text"
					class="form-control"
					[bsConfig]="bsConfig"
					#dp="bsDatepicker"
					bsDatepicker
					[(bsValue)]="monthDatePickerValue"
					style="text-transform: uppercase"
					(bsValueChange)="updateMonthData()"
				/>
			</div>
			<div class="col-xs-12 col-md-2 col-lg-2 form-group">
				<button
					class="btn theme-green-button"
					(click)="dp.toggle()"
					type="button"
				>
					Sélectionner un mois
				</button>
			</div>
		</div>

		<app-week-selector
			*ngIf="isReportTypeTabActive(2) || (!isTabActive(1) && !isTabActive(4))"
			class="col mt-4 theme-main-color d-flex justify-content-center"
			[weekNumber]="selectedWeek"
			[yearNumber]="selectedYear"
			(dateRangeChange)="updateWeekReportData()"
		></app-week-selector>
	</div>

	<div *ngIf="!loading && !isTabActive(5)">
		<!-- Le +1 est lié au fait que le monthDatePicker commence l'indexation des mois à 0 (Janvier = 0, Février = 1...)-->
		<app-activity-report
			*ngIf="isTabActive(1) && statsBeneficiaire"
			[isSESSAD]="isSESSAD"
			[statsEmployee]="statsEmployee"
			[statsBeneficiaire]="statsBeneficiaire"
			[dailyReports]="dailyReports"
			[monthDate]="monthDatePickerValue"
			[isReportByMonth]="isReportTypeTabActive(1)"
		></app-activity-report>

		<app-statistiques
			*ngIf="isTabActive(2) && statsDataAvailable"
			[globalStats]="globalStats"
			[lpcStats]="lpcStats"
			[lsfStats]="lsfStats"
			[pdnStats]="pdnStats"
			[unassignedStats]="unassignedStats"
			[oralStats]="oralStats"
			[stats]="stats"
			[statsEmployee]="statsEmployee"
		></app-statistiques>

		<app-funder-report
			*ngIf="isTabActive(3) && funderReport"
			[funderReport]="funderReport"
			[funders]="funders"
		></app-funder-report>

		<app-vacation-report
			*ngIf="isTabActive(4)"
			[employees]="employees"
		></app-vacation-report>

		<app-no-data-available
			*ngIf="isDataUnavailable()"
			[isReportByMonth]="isReportTypeTabActive(1) && isTabActive(1)"
		></app-no-data-available>
	</div>

	<div *ngIf="isTabActive(5)">
		<app-rapport-activite></app-rapport-activite>
	</div>

	<app-loading *ngIf="loading"></app-loading>
</div>
